import React from "react";
import { Box, Typography, Paper, alpha, Stack } from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { useTheme } from "@mui/material/styles";

const RateCalculationDisplay = ({ calculatedRate }) => {
  const theme = useTheme();

  if (calculatedRate === undefined || calculatedRate === null) {
    return null;
  }

  const formatPercentage = (rate) => {
    if (typeof rate !== "number") return rate;
    return (rate * 100).toFixed(6) + "%";
  };

  const rateAsPercent = formatPercentage(calculatedRate);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 2,
        borderRadius: 2,
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02),
        border: "1px solid",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.1),
      }}
    >
      <Stack spacing={2}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            }}
          >
            <CalculateIcon color='primary' />
          </Box>
          <Box>
            <Typography variant='h6' fontWeight={600} color='primary.main'>
              Interest Rate Calculation
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            p: 2.5,
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
            border: "1px solid",
            borderColor: (theme) => alpha(theme.palette.primary.main, 0.15),
          }}
        >
          <Stack direction='row' spacing={2} alignItems='baseline'>
            <Typography
              variant='body2'
              color='text.secondary'
              fontWeight={500}
              sx={{ minWidth: 180 }}
            >
              Calculated Interest Rate:
            </Typography>
            <Typography
              variant='h5'
              fontWeight={700}
              color='primary.main'
              sx={{
                fontFamily: "monospace",
                letterSpacing: 0.5,
              }}
            >
              {rateAsPercent}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

export default RateCalculationDisplay;
